import { RECURRING_DEPOSIT_STATUSES } from "@tastyworks/shared-utils/misc/constants"
import { RestResource } from "../common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "../deser"
import { IRA_DETAIL_DESER, IraDetail } from "../ira-detail"
import { ACH_RELATIONSHIP_DESER, AchRelationship } from "./ach-relationship"
import {
  getFrequencyFromPeriodAndInterval,
  type RECURRING_PERIODS,
} from "./shared"

export class RecurringDeposit extends RestResource {
  achRelationship?: AchRelationship
  achRelationshipId = 0
  accountNumber = ""
  amount = 0
  createdAt?: Date
  interval = 0
  iraDetail?: IraDetail
  isCancelable = false
  period?: RECURRING_PERIODS
  startDate?: Date
  state = RECURRING_DEPOSIT_STATUSES.PRE_SEND

  get isCanceled() {
    return this.state === RECURRING_DEPOSIT_STATUSES.CANCELED
  }

  get frequency() {
    return getFrequencyFromPeriodAndInterval(this.period ?? null, this.interval)
  }

  get isLoginExpired(): boolean {
    return this.achRelationship?.isLoginExpired ?? false
  }
}

export const RECURRING_DEPOSIT_DESER: SchemaDeSer<RecurringDeposit> =
  new SchemaDeSerBuilder(RecurringDeposit)
    .ofNested("achRelationship", ACH_RELATIONSHIP_DESER, AchRelationship)
    .ofInt("achRelationshipId")
    .ofString("accountNumber")
    .ofFloat("amount")
    .ofDateTime("createdAt")
    .ofString("id")
    .ofInt("interval")
    .ofNested("iraDetail", IRA_DETAIL_DESER, IraDetail)
    .ofBoolean("isCancelable")
    .ofString("period")
    .ofDate("startDate")
    .ofString("state")
    .toDeSer()
